export const FIRST_ORIENTATION_TYPE_ID = 0;
